export default __webpack_public_path__ + "static/media/caera-5.fdbe2064.mp4";